import defaultTheme from './default-theme';
import roke from './roke-colour-palette';

// When updating any colours in here you must also update the corresponding CSS variables in src/css-variables.scss

const geollectTheme = {
  ...defaultTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: roke.neutral2.n50, // #F3F3F3
      light: roke.primary.p100, // #6F7A96
      dark: roke.primary.p300, // #3C496B
    },
    secondary: {
      main: roke.primary.p400, // #2A395C
      contrastText: roke.primary.p500, // #12284C
      light: roke.tertiary.t400, // #396A9A
    },
    background: {
      default: roke.primary.p500, // #12284C
      menuBorder: roke.secondary.s700, // #54A037
      light: roke.highlight.h400, // #7EC5D0
    },
    text: {
      primary: roke.neutral2.n50, // #F3F3F3
      secondary: roke.neutral2.n400, // #B5B5B5
      contrastText: roke.primary.p500, // #12284C
      default: roke.neutral2.n800, // #3D3D3D
    },
    error: {
      main: roke.error.e300, // #E7888F
      light: roke.error.e200, // #EDAEB2
      dark: roke.error.e500, // #FF595A
    },
    warning: {
      main: roke.warning.w600, // #F38227
      light: roke.warning.w200, // #F4C38C
      dark: roke.warning.w500, // #F88D2A
    },
    success: {
      main: roke.secondary.s500, // #6CC34A
      light: roke.secondary.s800, // #47902C
      dark: roke.secondary.s900, // #35711E
    },
    info: {
      main: roke.tertiary.t50, // #B1C6ED
      dark: roke.neutral1.n800, // #777777
      light: roke.primary.p50, // #8E90A9
    },
    action: {
      hover: roke.primary.p300, // #3C496B
    },
    divider: roke.secondary.s700, // #54A037
    white: '#fff',
    black: '#000',
  },
  shape: {
    borderRadius: 1.5,
  },
};

export default geollectTheme;
